<script setup lang="ts">
import { UiAvatar, UiText } from "@shopexperts/shared";
import { quoteCopy } from "@/v2Projects/utils/quoteCopy";

defineProps<{
  senderName: string;
  senderAvatar?: string;
  senderInitials?: string;
  expertRole?: string | null;
}>();
</script>

<template>
  <section class="flex items-center gap-3">
    <UiAvatar
      size="md"
      :url="senderAvatar"
      :initials="senderInitials"
      :name="senderName"
      :responsive="false"
      color-coded
    />
    <div class="min-w-0 flex flex-col gap-1 max-sm:gap-0.5">
      <UiText as="h4" class="truncate text-se-dark font-medium">
        {{ senderName }}
      </UiText>
      <UiText as="span" variant="h5" class="text-se-gray-500 max-sm:hidden">
        {{ expertRole || quoteCopy.proposalDetails.expertRoleFallback }}
      </UiText>
      <UiText as="span" variant="h6" class="hidden text-se-gray-500 max-sm:inline">
        {{ expertRole || quoteCopy.proposalDetails.expertRoleFallback }}
      </UiText>
    </div>
  </section>
</template>
